"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions


var Fragment = _react["default"].Fragment; // ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** addClientDetection */

var addClientDetection = function addClientDetection(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(_class, _React$Component);
    /** standard constructor */


    function _class(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.state = {
        isClient: false
      };
      return _this;
    }
    /**
     * [componentDidMount description]
     * @return {[type]} [description]
     */


    var _proto = _class.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.setState({
        isClient: true
      });
    }
    /** render */
    ;

    _proto.render = function render() {
      var isClient = this.state.isClient;
      return /*#__PURE__*/_react["default"].createElement(Fragment, null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, this.props, {
        isClient: isClient
      })));
    };

    return _class;
  }(_react["default"].Component);
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = addClientDetection;
exports["default"] = _default;
module.exports = exports.default;